export default "__VITE_PUBLIC_ASSET__55b29742__"